import { observer } from 'mobx-react-lite'
import { Alert, Button } from 'shared/ui'
import { DefaultModalActions } from 'shared/ui/Modal/ui/DefaultModal/DefaultModalActions'
import { RadioOptions } from 'shared/ui/Radio'
import { type FlowDeleteActionStore } from '../FlowDeleteActionStore'
import styles from './styles.module.scss'

export const Content = observer(({ store }: { store: FlowDeleteActionStore }) => {
  const { onClose, onDelete, isNextDelete, setNextDelete } = store
  return (
    <>
      <div className={styles.alert}>
        <Alert
          item={{
            type: 'infoLight',
            desc: 'Do you want to delete this action only, or all the subsequent ones as well?',
          }}
        />
      </div>
      <div className={styles.wrapOptions}>
        <RadioOptions
          options={[
            {
              id: 'only',
              value: 'only',
              text: 'Delete this action only',
            },
            {
              id: 'following',
              value: 'following',
              text: 'Delete this action and all following actions',
            },
          ]}
          active={isNextDelete ? 'following' : 'only'}
          onChange={(id: string) => setNextDelete(id === 'following')}
        />
      </div>
      <DefaultModalActions>
        <Button
          typeBtn={'contained'}
          text={'Cancel'}
          size={'medium'}
          contained={'secondary'}
          onClick={onClose}
        />
        <Button
          typeBtn={'contained'}
          text={'Delete'}
          size={'medium'}
          contained={'primary'}
          onClick={onDelete}
        />
      </DefaultModalActions>
    </>
  )
})
